<template>
	<currency-input
	    v-model="displayValue"
	    class="form-control"
	    :distraction-free="distractionFree"
	    :currency="currency"
	    :locale="locale"/>
</template>
<script>
	export default{
		props: ['value'],

		data(){
			return {
				position: 'prefix',
				hideNegligibleDecimalDigits: false,
				hideCurrencySymbol: false,
				hideGroupingSymbol: false,
				locale: 'en'
			}
		},

		computed: {
			displayValue: {
	            get: function() {
	            	return parseFloat(this.value)
	            },
	            set: function(modifiedValue) {
	            	this.$emit('input', modifiedValue)
	            }
	        },
            distractionFree () {
		    	return {
					hideNegligibleDecimalDigits: this.hideNegligibleDecimalDigits,
					hideCurrencySymbol: this.hideCurrencySymbol,
					hideGroupingSymbol: this.hideGroupingSymbol
				}
			},

		    currency () {
		    	return { [this.position]: null }
		    }
		},

		watch: {
			value: function(val){
				this.displayValue = val || 0
			}
		}
	}
</script>